<div class="stars" [class.active]="active" [class.big]="big">
    <span [class]="getClass(1)" (click)="setRate(1);"></span>
    <span [class]="getClass(2)" (click)="setRate(2);"></span>
    <span [class]="getClass(3)" (click)="setRate(3);"></span>
    <span [class]="getClass(4)" (click)="setRate(4);"></span>
    <span [class]="getClass(5)" (click)="setRate(5);"></span>
</div>
